import styled, {ThemeProps} from 'styled-components';
import {Theme} from './../../../stories/theme/types';

// export const BodyWrapperStyle = styled.section`
//   display: flex;
//   width: 100%;
//   flex-direction: column;
// `;

export const MainSectionWrapper = styled.section(
  props => `
  // display: flex;
  // flex-direction: column;
  // align-items:center;
  // width: 100%;
  background: ${props.theme.colors.goBrandBlue.medium};
  position:sticky;
  top: ${props.theme.spacing.custom(86)};
  z-index: ${props.theme.misc.zIndex.base};
`,
);

export const BodyWrapperContentStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  display: flex;
  width: 100%;
  padding: ${props.theme.spacing.base} 0;
  max-width: 120rem;
  margin: ${props.theme.spacing.custom(30)} auto;
`,
);

export const RightSectionWrapperStyle = styled.section`
  display: flex;
  flex-direction: column;
  width: 78%;
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 95%;
    margin: 0 auto;
  }
  position: relative;
  /* margin-left: 26rem; */
`;

export const LeftSectionWrapperStyle = styled.section(
  (props: ThemeProps<Theme>) => `

  width:20%;
  align-self: flex-end;
  position: sticky;
  bottom: 2rem;
  margin-right: ${props.theme.spacing.xlarge};
  @media (min-width: 768px) and (max-width: 1024px) {
    display:none;
  }
`,
);

export const SeoBreadCrumbOuterWrapperDiv = styled.section(
  props => `

  background-color: transparent;
  max-width: 120rem;
  margin: 0 auto;
  padding: ${props.theme.spacing.base} 0 0 0;
  display: flex;
  width: 100%;
  flex-direction: column;

`,
);

export const SeoSrpPageTitle = styled.h1(
  props => `
  font-size: ${props.theme.font.custom(22)};
  font-family: ${props.theme.font.fontFamily};
  font-weight:bold;
  
  margin: ${props.theme.spacing.large} 0;
  `,
);

export const GoSafeCardBlockWrapper = styled.div(
  props => `
   margin-bottom: ${props.theme.spacing.base};
   border: .1rem solid ${props.theme.colors.ash.medium};

  `,
);
